import React, { PureComponent } from 'react'
import { Paper, Table, Typography, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'

import { PricesBodyRow } from './components'

export class PricesBase extends PureComponent {
  renderPlaceholder = () => (
    <Typography variant='h4' className={this.props.classes.placeholder}>
      Оберіть маршрут
    </Typography>
  )

  renderHeadCell = ({ id, label }, i) => {
    const { classes, routeCities } = this.props

    const lastCell = routeCities.length === i + 1

    return (
      <TableCell
        key={id}
        padding={lastCell ? 'dense': 'none'}
        className={classes.tableCell}
      >
        {label.slice(0, 10)}
      </TableCell>
    )
  }

  renderBodyRow = (data, i) => <PricesBodyRow key={i} data={data} /> 

  renderPrices = () => {
    const { routeCities, connectionPrices } = this.props

    return (
      <Paper>
        <Table>

          <TableHead>
            <TableRow>
              <TableCell padding='none' />
              {routeCities.map(this.renderHeadCell)}
            </TableRow>
          </TableHead>

          <TableBody>
            {connectionPrices.map(this.renderBodyRow)}
          </TableBody>
          
        </Table>
      </Paper>
    )
  }

  render() {
    const { fromUaRoute } = this.props

    return fromUaRoute
      ? this.renderPrices()
      : this.renderPlaceholder()
  }
}



// WEBPACK FOOTER //
// ./src/components/Prices/Prices.js